<script>
import gql from "graphql-tag"
import jsPDF from "jspdf"

export default {
	name: "TicketPrint",
	data() {
		return {
			loading: true,
			ticket: null
		}
	},

	async beforeMount() {
		this.loading = true
		if (!this.$route.params.id) this.$router.go(-1)
		await this.loadTicket()
		this.loading = false
	},

	methods: {
		loadTicket() {
			return this.$apollo
				.query({
					query: gql`
						query($id: ID!) {
							ticket(id: $id) {
								id
								code
								currencySymbol
								price
								type
								holder {
									id
									name
									lastname
									email
								}
								ticketType {
									id
									name
									ticketGroup {
										id
										name
										validAt
										event {
											id
											name
											startAt
											image {
												id
												url
												urlThumb
											}
											location {
												id
												name
												address
												locality {
													id
													name
													region {
														id
														name
													}
												}
											}
										}
									}
								}

								order {
									id
									paidAt
									user {
										id
										name
										lastname
										email
										documentText
									}
									status
								}
								canRequestRefund
								status
								statusText
								statusClass
							}
						}
					`,
					variables: {
						id: this.$route.params.id
					},
					fetchPolicy: "network-only"
				})
				.then(({ data }) => {
					this.ticket = data.ticket
					this.loading = false
				})
		},
		print() {
			const doc = new jsPDF()

			let ticketWidth = 180
			let ticketHeight = 60
			let ticketX = doc.internal.pageSize.width / 2 - ticketWidth / 2
			let ticketY = 20

			for (let i = 1; i <= 1; i++) {
				//imagen de fondo
				doc.addImage(
					require("@/assets/img/ticket-print-template.png"),
					"PNG",
					ticketX,
					ticketY,
					ticketWidth,
					ticketHeight
				)

				// imagen del evento
				doc.addImage(
					this.ticket.ticketType.ticketGroup.event.image.url,
					"PNG",
					ticketX + 2,
					ticketY + 2,
					38,
					38
				)

				// bloque de datos evento
				let dataX = ticketX + 43
				let dataY = ticketY + 14

				// event name
				doc.setTextColor(0, 0, 0)
				doc.setFont(undefined, "normal")
				doc.setFontSize(19)
				doc.text(this.ticket.ticketType.ticketGroup.event.name, dataX, dataY)

				// ubicacion
				dataY += 6
				doc.setFontSize(12)
				doc.text(this.ticket.ticketType.ticketGroup.event.location.name, dataX, dataY)

				// direccion
				dataY += 4
				doc.setFontSize(9)
				doc.setTextColor(100, 100, 100)
				doc.text(
					`${this.ticket.ticketType.ticketGroup.event.location.address} - ${this.ticket.ticketType.ticketGroup.event.location.locality.name} ${this.ticket.ticketType.ticketGroup.event.location.locality.region.name}`,
					dataX,
					dataY
				)

				// fecha
				dataY += 8
				doc.setFontSize(16)
				doc.setTextColor(0, 0, 0)
				doc.setFont(undefined, "bold")
				doc.text(
					this.$moment(this.ticket.ticketType.ticketGroup.event.startAt)
						.format("DD MMM YYYY")
						.toUpperCase(),
					dataX,
					dataY
				)
				dataY += 5.5
				doc.text(
					this.$moment(this.ticket.ticketType.ticketGroup.event.startAt)
						.format("HH:mm")
						.toUpperCase(),
					dataX,
					dataY
				)

				//bloques de tipo de entrada y holder
				let blockWidth = 56
				let blockHeight = 16
				let blockX = ticketX + 2
				let blockY = ticketY + ticketHeight - blockHeight - 2

				if (this.ticket.holder || this.ticket.order.user) {
					doc.setFillColor(235, 235, 235)
					doc.rect(blockX, blockY, blockWidth, blockHeight, "F")
					doc.setFontSize(8).setFont(undefined, "normal")
					doc.setTextColor(100, 100, 100)
					doc.text("CLIENTE", blockX + 3, blockY + 4)

					doc.setTextColor(0, 0, 0)
					doc.setFontSize(12).setFont(undefined, "normal")
					if (this.ticket.order.user) {
						doc.text(
							`${this.ticket.order.user.name} ${this.ticket.order.user.lastname}`,
							blockX + 3,
							blockY + 9
						)

						doc.setFontSize(10).setFont(undefined, "normal")
						doc.text(`${this.ticket.order.user.documentText}`, blockX + 3, blockY + 13)
					}

					blockX += blockWidth + 2
				}

				doc.setFillColor(235, 235, 235)
				doc.rect(blockX, blockY, blockWidth, blockHeight, "F")
				doc.setFontSize(8).setFont(undefined, "normal")
				doc.setTextColor(100, 100, 100)
				doc.text("TICKET", blockX + 3, blockY + 4)
				doc.setTextColor(0, 0, 0)
				doc.setFontSize(12).setFont(undefined, "normal")
				doc.text(`${this.ticket.ticketType.name}`, blockX + 3, blockY + 9)
				doc.setFontSize(10).setFont(undefined, "normal")
				doc.text(`${this.ticket.ticketType.ticketGroup.name}`, blockX + 3, blockY + 13)

				blockX += blockWidth + 2

				// precio
				doc.setFillColor(235, 235, 235)
				doc.rect(blockX, blockY, 23, blockHeight, "F")

				if (this.ticket.type == "COURTESY") {
					doc.setFontSize(10).setFont(undefined, "bold")
					doc.text(`CORTESÍA`, blockX + 3 + 17.5, blockY + 9.5, null, null, "right")
				} else {
					doc.setFontSize(13).setFont(undefined, "bold")
					doc.text(
						`${this.ticket.currencySymbol} ${this.ticket.price}`,
						blockX + 3 + 15,
						blockY + 10,
						null,
						null,
						"right"
					)
				}

				// QR
				doc.addImage(
					`${this.API_URL}/qr/${this.ticket.code}.png`,
					"PNG",
					ticketX + ticketWidth - 36,
					ticketY + 1,
					35,
					35
				)

				// valido hasta
				doc.setFontSize(8).setFont(undefined, "bold")
				doc.setTextColor(100, 100, 100)
				doc.text(`VALIDO HASTA:`, ticketX + ticketWidth - 18, ticketY + 40, null, null, "center")
				doc.setTextColor(100, 100, 100)
				doc.text(
					`${this.$moment(this.ticket.ticketType.ticketGroup.validAt).format("ddd DD [de] MMMM HH:mm")}`,
					ticketX + ticketWidth - 18,
					ticketY + 43,
					null,
					null,
					"center"
				)

				// margen para otro ticket
				ticketY += ticketHeight + 10
			}

			doc.save(`ticket-${this.ticket.ticketType.ticketGroup.event.name}-${this.ticket.code}.pdf`)
		}
	}
}
</script>

<style scoped lang="scss"></style>
